import {
    Box,
    Button,
    Container,
    makeStyles,
    Typography,
} from "@material-ui/core";
import React, { useEffect, useState } from "react";
import Navbar from "../Navbar/Navbar";
import StoryCardSmall, { Story } from "../StoryCardSmall/StoryCardSmall";
import CategoryCard, { CategoryProps } from "./CategoryCard/CategoryCard";
import ProducerNav from "../ProducerNav/ProducerNav";
import config from "../../config/apiConfig";
import Cookies from "js-cookie";
import { RouteComponentProps } from "react-router";
import Banner from "./Banner/Banner";

const useStyles = makeStyles((theme) => ({
    horList: {
        display: "flex",
        width: "100%",
        overflowX: "auto",
    },
    heading: {
        marginTop: 40,
        marginBottom: 24,
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
    },
}));

const ProducerMain: React.FC<RouteComponentProps> = ({ history }) => {
    const classes = useStyles();
    const [topTrending, setTopTrending] = useState<Story[]>([]);
    const [viewed, setViewed] = useState<Story[]>([]);
    const [topCritic, setTopCritic] = useState<Story[]>([]);
    const [categories, setCategories] = useState<CategoryProps[]>([]);

    useEffect(() => {
        const requestOptions: RequestInit = {
            method: "POST",
            body: null,
            headers: {
                "Access-Control-Allow-Origin": "*",
                session_token: Cookies.get("token") ?? "",
                token: config.token,
            },
        };

        const promise1 = fetch(
            config.BASE_URL +
                "/v2/api/story/getAll?page=1&pageSize=10&orderBy=4",
            requestOptions
        )
            .then((res) => res.json())
            .then((res) => setTopTrending(res));

        const promise2 = fetch(
            config.BASE_URL +
                "/v2/api/story/getAll?page=1&pageSize=10&orderBy=2",
            requestOptions
        )
            .then((res) => res.json())
            .then((res) => setTopCritic(res));

        const promise3 = fetch(
            config.BASE_URL + "/v2/api/story/continueReading",
            requestOptions
        )
            .then((res) => res.json())
            .then((res) => setViewed(res));

        const promise4 = fetch(
            config.BASE_URL + "/v2/api/category/allGenre",
            requestOptions
        )
            .then((res) => res.json())
            .then((res) => setCategories(res));

        Promise.all([promise1, promise2, promise3, promise4]).catch((error) =>
            console.error(error)
        );
    }, []);

    return (
        <React.Fragment>
            <ProducerNav />
            <Box height={60} />
                <Banner />
            <Container maxWidth="lg">
                <Box className={classes.heading}>
                    <Typography variant="h5" component="h2">
                        Top Trending Stories
                    </Typography>
                    <Button
                        size="small"
                        onClick={() => history.push("/producer/top-trending")}
                    >
                        View More
                    </Button>
                </Box>
                <div className={classes.horList}>
                    {topTrending.map((s) => (
                        <StoryCardSmall
                            key={s.storyId}
                            style={{ marginRight: 24 }}
                            onRemove={() =>
                                setTopTrending(
                                    topTrending.filter((t) => t !== s)
                                )
                            }
                            {...s}
                        />
                    ))}
                </div>

                <Typography
                    className={classes.heading}
                    variant="h5"
                    component="h2"
                >
                    Explore by categories
                </Typography>
                <div className={classes.horList}>
                    {categories.map((c) => (
                        <CategoryCard key={c.genre} {...c} />
                    ))}
                </div>

                <Typography
                    className={classes.heading}
                    variant="h5"
                    component="h2"
                >
                    Continue reading
                </Typography>
                <div className={classes.horList}>
                    {viewed.map((s) => (
                        <StoryCardSmall
                            key={s.storyId}
                            style={{ marginRight: 24 }}
                            onRemove={() =>
                                setTopTrending(
                                    viewed.filter((t) => t !== s)
                                )
                            }
                            {...s}
                        />
                    ))}
                </div>

                <Box className={classes.heading}>
                    <Typography variant="h5" component="h2">
                        From Top Critics
                    </Typography>
                    <Button
                        size="small"
                        onClick={() => history.push("/producer/top-critics")}
                    >
                        View More
                    </Button>
                </Box>
                <div className={classes.horList}>
                    {topCritic.map((s) => (
                        <StoryCardSmall
                            key={s.storyId}
                            style={{ marginRight: 24 }}
                            onRemove={() =>
                                setTopCritic(topCritic.filter((t) => t !== s))
                            }
                            {...s}
                        />
                    ))}
                </div>

                <Box height={64} />
            </Container>
        </React.Fragment>
    );
};

export default ProducerMain;
